module.exports = __webpack_public_path__ + "static/media/icon_file_so.7decfb1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_so.svg
// module id = 159
// module chunks = 0